import { useEffect, useState } from "react";

function ytEmbed(url) {
  const m = url.match(/(?:youtu\.be\/|v=)([\w-]{6,})/);
  return m ? `https://www.youtube.com/embed/${m[1]}?autoplay=1&mute=1&loop=1&playlist=${m[1]}&controls=0` : null;
}

// Auto cross-fading hero carousel. Falls back to a single fallback image.
export default function HeroMediaCarousel({ media = [], fallback }) {
  const items = media.length ? media : (fallback ? [{ id: "fb", type: "image", url: fallback, source: "link" }] : []);
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (items.length <= 1) return;
    const t = setInterval(() => setIdx(i => (i + 1) % items.length), 5000);
    return () => clearInterval(t);
  }, [items.length]);

  if (!items.length) return (
    <div className="nb-card p-3 -rotate-2"><div className="w-full h-80 rounded-md border-2 border-black bg-slate-100 grid place-items-center text-slate-400">No hero media</div></div>
  );

  return (
    <div className="relative w-full h-80 rounded-xl border-2 pf-border overflow-hidden" data-testid="hero-carousel">
      {items.map((m, i) => {
        const active = i === idx;
        const yt = m.type === "video" && m.source === "link" ? ytEmbed(m.url) : null;
        return (
          <div key={m.id || i}
            className="absolute inset-0 transition-opacity duration-1000"
            style={{ opacity: active ? 1 : 0, pointerEvents: active ? "auto" : "none" }}
            data-testid={`hero-slide-${i}`}>
            {m.type === "video"
              ? (yt
                  ? <iframe title={m.title || "hero"} src={yt} className="w-full h-full" allow="autoplay; encrypted-media" frameBorder="0" />
                  : <video src={m.url} autoPlay muted loop playsInline className="w-full h-full object-cover" />)
              : <img src={m.url} alt={m.title || "hero"} className="w-full h-full object-cover" />}
          </div>
        );
      })}
      {items.length > 1 && (
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
          {items.map((_, i) => (
            <button key={i} onClick={() => setIdx(i)} data-testid={`hero-dot-${i}`}
              className={`w-2.5 h-2.5 rounded-full border-2 pf-border ${i === idx ? "pf-accent-bg" : "bg-white/70"}`} />
          ))}
        </div>
      )}
    </div>
  );
}
